import {IAnimeVideoPreview, IOneAnimeJson} from "../../../../nodeserver/structs/database";
import {YoutubeApi} from "../iframe-apis/youtube-api.js";
import JSX from "../helpers/react.js";

export class PreviewAnimeItem{
    private readonly $element: JQuery;
    private constructor(public readonly data: IAnimeVideoPreview) {
        this.$element = this.createElement();
        this.setEvents();
    }
    private get inputs(): [JQuery<HTMLInputElement>, JQuery<HTMLInputElement>, JQuery<HTMLInputElement>]{
        return [
            this.$element.find<HTMLInputElement>('input[name=hours]'),
            this.$element.find<HTMLInputElement>('input[name=minutes]'),
            this.$element.find<HTMLInputElement>('input[name=seconds]')
        ];
    }
    private setEvents(){
        this.$element
            .on('click', '.load-current-position', (e)=>{
                e.preventDefault();
                this.loadCurrentVideoPosition();
            })
            .on('input', '.time-numbers input',function(this: HTMLInputElement){
                PreviewAnimeItem.leadingZeros($(this));
            })
            .on('focus', '.time-numbers input', function (){$(this).val('').val('00')})
            .on('click', '.close-btn', ()=>this.$element.fadeOut().promise().done(()=>this.$element.remove()))

    }
    public get timing(): number{
        const [hours, minutes, seconds] = this.inputs;
        return +hours.val()! * 3600 + (+minutes.val()!) * 60 + (+seconds.val()!);
    }
    private static leadingZeros(input: JQuery<HTMLInputElement>) {
        let val = input.val()!.toString();
        if(!isNaN(+val) && val.length === 1) {
            input.val('0' + val);
        }
        else if(val.length > 2){
            input.val(val.substring(val.length - 2));
        }
        if(val.length >= 2 && (input.val()!.toString()![0]) !== '0' && input.is(document.activeElement!)){
            const $input = input.next().trigger('focus');
        }
    }
    private createElement(): JQuery{
        const ans = $(<div className="anime-column anime-preview" data-anime-id={this.data.anime_id}>
        <div className="close-btn fa fa-times-circle" title="Удалить" />
        <div className="image-block">
            <span className="year-block">{this.data.year}</span>
            <span className="status-block" data-val={this.data!.anime_status.value}>{this.data.anime_status.title}</span>
            <img src={this.data.poster.big} loading="lazy" alt={escapeHtml(this.data.title)} />
        </div>
        <div className="anime-column-info">
            <span className="anime-title">{escapeHtml(this.data.title)}</span>
            <div>{this.data.type.shortname}</div>
        </div>
        <button className="main-button load-current-position bordered">Подгрузить позицию</button>
        <div className="time-numbers">
            <input type="number" value={Math.floor((this.data.time??0)/3600)} min="0" max="23" name="hours" placeholder="Ч" />
            :
            <input type="number" value={Math.floor((this.data.time??0)/60%60)} min="0" max="59" name="minutes" placeholder="ММ" />
            :
            <input type="number" value={Math.floor((this.data.time??0)%60)} min="0" max="59" name="seconds" placeholder="СС" />
        </div>
    </div>);
        for(const i of Array.from(ans.find('input[type=number]')) as HTMLInputElement[])
            PreviewAnimeItem.leadingZeros($(i));
        ans.data('item', this);
        return ans;

    }
    public appendTo($el: JQuery){this.$element.appendTo($el)}
    static create(element: IAnimeVideoPreview, $container: JQuery){
        const ans = new PreviewAnimeItem(element);
        ans.appendTo($container);
        return ans;
    }
    public static get elements(): PreviewAnimeItem[]{
        return Array.from($(".anime-preview")).map(e=>$(e).data('item') as PreviewAnimeItem);
    }

    private loadCurrentVideoPosition() {
        let pos = YoutubeApi.Instance.currentPos;
        const seconds = Math.floor(pos % 60);
        pos /= 60;
        const minutes = Math.floor(pos % 60);
        pos /= 60;
        const hours = Math.floor(pos);
        const [hoursEl, minutesEl, secondsEl] = this.inputs;
        hoursEl.val(hours);
        minutesEl.val(minutes);
        secondsEl.val(seconds);
        //padding 0
        for(const input of this.inputs) PreviewAnimeItem.leadingZeros(input);
    }
}
